// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"1a46c6c1","123":"fe57f82f","239":"9ceccdc3","267":"e2f43165","317":"e413365a","365":"9688b965","488":"57399a51","638":"daf468ad","729":"3a016d22","809":"b255ae03"}[chunkId] + ".chunk.js";
};